import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { VisionService } from '../services/vision.service';
import { JobService } from '../services/job.service';
import { CriteriaService } from '../services/criteria.service';
import { SpinnerService } from '../services/spinner';
import { VisionModel } from '../models/vision.model';
import { SurveyDetails } from '../models/dto/survey';
import { SurveyTypes } from '../models/surveytypes';
import { CriteriaDetails } from '../models/dto/criteria';
import { OffersOrderMatch } from '../models/dto/offers-order-match';
import { OffersModel } from '../models/offers.model';
import { AnswerDetails } from '../models/dto/answer-details';
import { OffersCompleteLevel } from '../models/dto/offers-complete-level';
import { AnswerShort } from '../models/dto/answer-short';
import { Observable } from 'rxjs/Rx';

@Component({
  selector: 'app-jobs-added',
  templateUrl: './jobs-added.component.html',
  styleUrls: ['./jobs-added.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class JobsAddedComponent implements OnInit {
  current_survey: any;
  survey_data: SurveyDetails;
  vision_title: string;
  orderingDisplay = false;
  isChangeVision = false;
  survey_offers: any;
  closeResult: string;
  offersCount = 0;
  visionTypeId = 0;
  offers_order_array: Array<OffersOrderMatch> = [];
  offers_complete: Array<OffersCompleteLevel> = [];
  orderString = 'Taux de matching';
  visionId: string;
  total_criterias_count = 0;
  selected_offer: OffersOrderMatch;
  selected_percentage = '';
  selected_complete_percentage = '';
  selected_completeTitle = '';
  selected_completeDescription = '';
  selected_completeDescription_arr = [];
  selected_completeDescriptionBelow = '';
  selected_completeDescriptionBelow_arr = [];
  selected_color = '';
  selected_smile = '';
  selected_criterias: Array<CriteriaDetails> = [];
  selected_answers: Array<AnswerDetails> = [];
  selected_criterias_up: Array<AnswerShort> = [];
  selected_criterias_up1: Array<AnswerShort> = [];
  selected_criterias_up2: Array<AnswerShort> = [];
  selected_criterias_down: Array<AnswerShort> = [];
  selected_criterias_selected: Array<AnswerShort> = [];
  selected_criterias_unselected: Array<CriteriaDetails> = [];
  selected_show_criterias_up = false;
  selected_show_criterias_down = false;
  selected_show_unselected = false;
  selected_show_negative = false;

  constructor(private jobService: JobService, private criteriaService: CriteriaService
    , private offersModel: OffersModel, private visionModel: VisionModel, private route: ActivatedRoute,
    private visionService: VisionService, private modalService: NgbModal, private surveyTypes: SurveyTypes,
    private spinnerService: SpinnerService) {

    this.current_survey = JSON.parse(localStorage.getItem('current_survey'));
  }

  ngOnInit() {
    this.spinnerService.show();
    this.offersModel.getCoef();
    this.route.params.subscribe(params => {
      if (params['visiontype']) {
        this.visionTypeId = params['visiontype'];
        this.isChangeVision = true;
      }
    });
    if (this.isChangeVision) {
      this.changeVision(this.visionTypeId);
    } else if (!this.current_survey || this.current_survey === 'null') {
      this.visionTypeId = this.visionModel.getCurrentSurveyTypeId();
      this.visionModel.setSurveyInStorageFromType(this.visionTypeId).subscribe(data => {
        this.current_survey = localStorage.getItem('current_survey');
        this.current_survey = JSON.parse(this.current_survey);
        this.vision_title = this.current_survey.title;
      });
    }
    if (this.current_survey && !this.isChangeVision) {  // if not change vision
      this.vision_title = this.current_survey.title;
      this.jobService.getVisionOffers(this.current_survey.id).subscribe(data => {
        this.survey_offers = data;
        this.fillOrderArray();
        setTimeout(() => {
          this.fillCompleteArray();
          this.spinnerService.hide();
        }, 500);
      });
    }
  }

  fillOrderArray() {
    if (this.survey_offers) {
      this.offersCount = this.survey_offers.Survey.offers.length;
      this.survey_offers.Survey.offers.forEach(offer => {
        let perc = 0;
        let offerCompletePercetage = 0;
        if (offer) {
          this.total_criterias_count = this.current_survey.criterias.length;
          setTimeout(() => {
            perc = this.getPercentage(offer);
            offerCompletePercetage = this.getCompletePercentage(offer);
            const criteriasCount = this.getCriteriaCount(offer.answers);
            const criteriaAnswers = offer.answers;
            const isExist = this.offers_order_array.filter(x => x.id === offer.id)[0];
            if (!isExist) {
              this.offers_order_array.push(
                {
                  id: offer.id,
                  title: offer.title,
                  address: offer.address,
                  companyname: offer.companyname,
                  smile: '',
                  description: this.writeReferenceString(offer.description),
                  date: offer.createdate,
                  criterias_count: criteriasCount,
                  percentage: perc,
                  completePercentage: offerCompletePercetage,
                  color: '',
                  answers: criteriaAnswers
                });
            }
            this.sort('percentage', 1);
            return Observable.of(true);
          }, 500);
        }
      });
    }
  }

  fillCompleteArray() {
    if (this.survey_offers) {
      this.survey_offers.Survey.offers.forEach(offer => {
        const offerDetails = this.survey_offers.Survey.offers.filter(x => x.id === offer.id)[0];
        const offerOrderItem = this.offers_order_array.filter(x => x.id === offer.id)[0];
        if (offerOrderItem && offerDetails) {
          const offerCompletePercetage = offerOrderItem.completePercentage;
          let offerResult: OffersCompleteLevel;
          offerResult = this.offersModel.getCompleteResult(offerDetails, offerOrderItem, offerCompletePercetage, this.current_survey);
          this.offers_complete.push(offerResult);
        }
      });
      this.addOrderArrayData();
    }
  }
  addOrderArrayData() {
    if (this.offers_order_array) {
      this.offers_order_array.forEach(offer => {
        const completeItem = this.offers_complete.filter(x => x.id === offer.id)[0];
        offer.color = this.getColorClass(completeItem.color);
        offer.smile = '/assets/svg/smilies.svg#smiley-' + completeItem.smile;
      });
    }
  }

  changeVision(visionTypeId) {
    this.spinnerService.show();
    localStorage.setItem('vision_title', this.surveyTypes.getTitle(visionTypeId));
    // this.visionTypeId = this.visionModel.getCurrentSurveyTypeId();
    this.visionModel.setSurveyInStorageFromType(this.visionTypeId).subscribe(data => {
      const currentSurvey = localStorage.getItem('current_survey');
      this.current_survey = JSON.parse(currentSurvey);
      this.vision_title = this.current_survey.title;
      this.jobService.getVisionOffers(this.current_survey.id).subscribe(resp => {
        this.survey_offers = resp;
        this.fillOrderArray();
        setTimeout(() => {
          this.fillCompleteArray();
          this.spinnerService.hide();
        }, 500);
      });
    });
  }

  changeView() {
    this.jobService.getVisionOffers(this.current_survey.id).subscribe(resp => {
      this.survey_offers = resp;
      this.offers_order_array = [];
      this.offers_complete = [];
      this.fillOrderArray();
      setTimeout(() => {
        this.fillCompleteArray();
      }, 500);
    });
  }
  removeOffer(offerId) {
    const selectedItem = this.offers_order_array.filter(x => x.id === offerId)[0];
    if (selectedItem) {
      const index: number = this.offers_order_array.indexOf(selectedItem);
      if (index !== -1) {
        this.offers_order_array.splice(index, 1);
      }
    }
  }

  displayOrdering() {
    this.orderingDisplay = true;
  }

  disableDropdowns() {
    this.orderingDisplay = false;
  }

  open(content) {
    this.modalService.open(content).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  openResultModal(content) {
    this.modalService.open(content, { windowClass: 'joffers-result' }).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  openEmptyModal(content) {
    this.modalService.open(content, { windowClass: 'joffers-modal-empty' }).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  openConfirmDeleteModal(content) {
    this.modalService.open(content, { windowClass: 'joffers-confirmDelete' }).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }



  getPercentage(offer): any {
    let calc = 0;
    let perc = 0;
    this.offersModel.getOfferMatchLevel(offer).subscribe(data => {
      calc = data;
      if (calc) {
        perc = Math.floor(calc * 100);
      }
    });
    return perc;
  }

  getCompletePercentage(offer) {
    let calc = 0;
    let perc = 0;
    this.offersModel.getCompleteLevel(offer, this.current_survey).subscribe(data => {
      calc = data;
      if (calc) {
        perc = Math.floor(calc * 100);
      }
    });
    return perc;
  }

  sort(property, dir) {
    const direction = -1 * dir;
    if (property === 'percentage' || property === 'date') {
      this.offers_order_array.sort(function (a, b) {
        if (a[property] < b[property]) {
          return -1 * direction;
        } else if (a[property] > b[property]) {
          return 1 * direction;
        } else {
          return 0;
        }
      });
    } else {
      this.offers_order_array.sort(function (a, b) {
        if (a[property].toLowerCase() < b[property].toLowerCase()) {
          return -1 * direction;
        } else if (a[property].toLowerCase() > b[property].toLowerCase()) {
          return 1 * direction;
        } else {
          return 0;
        }
      });
    }
  }

  writeReferenceString(reference: string) {
    if (reference) {
      reference = reference.replace(/(https?:\/\/[^\s]+)/gi, '<a href="$1" target="_blank"><span class="oi oi-external-link grey40"></span></a>');
    }
    return reference;
  }

  getCriteriaCount(answers: Array<AnswerDetails>): any {
    const criteria_list = Array.from(new Set(answers)).map((itemInArray) => itemInArray.criteria);
    return criteria_list.length;
  }

  sortClick(sortId) {
    if (sortId === 1) {
      this.orderString = 'Taux de matching';
      this.sort('percentage', 1);
    } else if (sortId === 2) {
      this.orderString = 'Ordre alphabétique';
      this.sort('title', -1);
    } else if (sortId === 3) {
      this.orderString = 'Localité';
      this.sort('address', -1);
    } else if (sortId === 4) {
      this.orderString = "Date de l'ajout";
      this.sort('date', 1);
    }
    this.orderingDisplay = false;
  }

  styleProgress(criteriasCount) {
    let selectedPrecentage = 0;
    selectedPrecentage = +((criteriasCount / this.total_criterias_count) * 100).toFixed(0);
    return { width: selectedPrecentage + '%' };
  }
  // when delete Offer clicked
  setOffer(offer: OffersOrderMatch) {
    this.selected_offer = offer;
  }

  // when display details clicked
  setCompleteValues(offer: OffersOrderMatch) {
    if (this.offers_complete) {
      const offerResult = this.offers_complete.filter(x => x.id === offer.id)[0];
      const offerResultOrder = this.offers_order_array.filter(x => x.id === offer.id)[0];
      if (offerResult) {
        this.selected_percentage = offer.percentage + '';
        this.selected_complete_percentage = offer.completePercentage + '';
        this.selected_completeTitle = offerResult.result_title;
        this.selected_completeDescription = offerResult.result_description;
        this.selected_completeDescription_arr = this.selected_completeDescription.split('XXX');
        this.selected_completeDescriptionBelow = offerResult.result_description_below;
        this.selected_completeDescriptionBelow_arr = this.selected_completeDescriptionBelow.split('XXX');
        this.selected_smile = '/assets/svg/smilies.svg#smiley-' + offerResult.smile;
        this.selected_criterias = offerResult.criterias;
        this.selected_color = this.getColorClass(offerResult.color);
        this.selected_answers = offerResult.answers;
        this.writeCriterias();
      }
    }
  }

  getColorClass(color: string) {
    let colorClass = '';
    if (color === 'grey') {
      colorClass = 'result-grey';
    } else if (color === 'dark red') {
      colorClass = 'result-dark-red';
    } else if (color === 'red 1') {
      colorClass = 'result-red1';
    } else if (color === 'red 2') {
      colorClass = 'result-red2';
    } else if (color === 'red 3') {
      colorClass = 'result-red3';
    } else if (color === 'orange 1') {
      colorClass = 'result-orange1';
    } else if (color === 'orange 2') {
      colorClass = 'result-orange2';
    } else if (color === 'orange 3') {
      colorClass = 'result-orange3';
    } else if (color === 'yellow 1') {
      colorClass = 'result-yellow1';
    } else if (color === 'yellow 2') {
      colorClass = 'result-yellow2';
    } else if (color === 'yellow 3') {
      colorClass = 'result-yellow3';
    } else if (color === 'lgreen 1') {
      colorClass = 'result-lgreen1';
    } else if (color === 'lgreen 2') {
      colorClass = 'result-lgreen2';
    } else if (color === 'lgreen 3') {
      colorClass = 'result-lgreen3';
    } else if (color === 'green 1') {
      colorClass = 'result-green1';
    } else if (color === 'green 2') {
      colorClass = 'result-green2';
    } else if (color === 'green 3') {
      colorClass = 'result-green3';
    }
    return colorClass;
  }

  percentageStyle(colorValue) {
    const styles = { 'color': colorValue };
    return styles;

  }

  writeCriterias() {
    this.selected_criterias_up = [];
    this.selected_criterias_up1 = [];
    this.selected_criterias_up2 = [];
    this.selected_criterias_down = [];
    this.selected_criterias_unselected = [];
    if (this.selected_completeDescription.includes('XXX')) {
      if (parseInt(this.selected_percentage) === 0) {
        this.selected_show_criterias_down = true;
      } else {
        this.selected_show_criterias_up = true;
      }
      this.selected_answers.forEach(answer => {
        console.log(answer);
        if (answer.option.importance < 4) { // Positive options selected
          const isExist = this.selected_criterias_up.filter(x => x.criteriaId === answer.criteria.id)[0];
          if (!isExist) {
            this.selected_criterias_up.push({
              criteriaId: answer.criteria.id, optionId: answer.option.id
              , crtieriaTitle: answer.criteria.title, optionTitle: answer.option.title
            });
            if (answer.option.importance < 3) {
              this.selected_criterias_up2.push({
                criteriaId: answer.criteria.id, optionId: answer.option.id
                , crtieriaTitle: answer.criteria.title, optionTitle: answer.option.title
              });
              if (answer.option.importance < 2) {
                this.selected_criterias_up1.push({
                  criteriaId: answer.criteria.id, optionId: answer.option.id
                  , crtieriaTitle: answer.criteria.title, optionTitle: answer.option.title
                });
              }
            }
          }
        }else{
          const isExist = this.selected_criterias_down.filter(x => x.criteriaId === answer.criteria.id)[0];
          if (!isExist) {
            this.selected_criterias_down.push({
              criteriaId: answer.criteria.id, optionId: answer.option.id
              , crtieriaTitle: answer.criteria.title, optionTitle: answer.option.title
            });
          }
        }
      });
      // this.selected_completeDescription = this.selected_completeDescription.replace('XXX', '');
    }
    if (this.selected_completeDescriptionBelow.includes('XXX')) {
      this.selected_show_unselected = true;
      this.selected_answers.forEach(answer => {
        const isExist = this.selected_criterias_selected.filter(x => x.criteriaId === answer.criteria.id)[0];
        if (!isExist) {
          this.selected_criterias_selected.push({
            criteriaId: answer.criteria.id, optionId: answer.option.id
            , crtieriaTitle: answer.criteria.title, optionTitle: answer.option.title
          });
        }
      });

      this.current_survey.criterias.forEach(crit => {
        const isExist = this.selected_criterias_selected.filter(x => x.criteriaId === crit.id)[0];
        if (!isExist) {
          console.log(crit);
          this.selected_criterias_unselected.push(crit);
        }
      });

      // this.selected_completeDescriptionBelow = this.selected_completeDescriptionBelow.replace('XXX', '');
      if (+this.selected_percentage > 50) {
        this.selected_show_negative = true;
      } else if (+this.selected_percentage < 50) {
        this.selected_show_negative = false;
      }
    }

    if (parseFloat(this.selected_complete_percentage) >= 90) {
      if (parseFloat(this.selected_percentage) >= 50 && parseFloat(this.selected_percentage) < 75) {
        if (this.selected_criterias_up1.length > 0) {
          this.selected_criterias_up = this.selected_criterias_up1;
        } else if (this.selected_criterias_up2.length > 0) {
          this.selected_criterias_up = this.selected_criterias_up2;
        }
      }
    }
  }

  deleteOffer(offerId) {
    const answerIds: Array<string> = [];
    this.selected_offer.answers.forEach(option => {
      answerIds.push(option.id);
    });
    let allMutations = `mutation {`;
    allMutations += this.criteriaService.buildDeleteAnswers2(answerIds);
    allMutations += this.jobService.buildDeleteOffer(offerId);
    allMutations += ' }';
    this.jobService.mutateEditOffer(allMutations).subscribe(resp => {
      this.removeOffer(offerId);
      document.getElementById('closedeleteModalButton').click();
    });
  }


}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/jobs/jobs-added.component.ts